import { Injectable } from '@angular/core';
import { BaseApi } from './_base-api';
import { BannerDetail, BannerEntity, BannerCreateParams, BannerUpdateParams, UpdateStatusModel, BrandEntity } from '@models';
import { map, Observable } from 'rxjs';
import { ItemRecord } from '@controladad/ng-base';

@Injectable({
    providedIn: 'root',
})
export class BannerApiService extends BaseApi<BannerEntity, BannerCreateParams, BannerUpdateParams> {
    constructor() {
        super(
            'banners', {
            get:
                '/AdminPanel/GetBannersList',
        })
    }
    getBannerDetail(id: number) {
        return http$.get<{ banner: BannerDetail }>(`/AdminPanel/GetBannerDetails?BannerId=${id}`);
    }

    getAllProducts(): Observable<ItemRecord<number>[]> {
        return super
            .getAll<any>(undefined, '/AdminPanel/GetProductNames')
            .pipe(map((products) => products.map((v) => ({ value: v.id, label: v.name.english }))));
    }

    getBrandItems(): Observable<ItemRecord<number>[]> {
        return super
            .getAll<BrandEntity>(undefined, '/AdminPanel/GetBrandList')
            .pipe(map((brands) => brands.map((b) => ({ label: b.name.english, value: b.id }))));
    }

    override create(model: BannerCreateParams): Observable<any> {
        return http$.post('/AdminPanel/AddBanner', model);

    }
    updateBanner(model: BannerUpdateParams): Observable<any> {
        return http$.put('/AdminPanel/EditBanner', model);
    }

    deleteBanners(ids: number[]) {
        return http$.delete('/AdminPanel/DeleteBanners', {
            body: {
                bannersIds: ids,
            },
        }
        );
    }

    updateStatus(model: UpdateStatusModel) {
        return http$.put('/Banner/ChangeBannerStatus', model);
    }
}
